/**
 * 화면 맨 위 얇은 한 줄 띠 (랜딩 + 판 도중 공통).
 *
 * 먹지 않는 높이: 한 줄, 판 도중에도 방해되지 않게 눈에 띄는 색이 아니라 종이 위 잉크 띠로 둔다.
 * 폰에서도 한 줄이어야 해서 문구를 두 벌 두고 CSS 로 고른다(말줄임으로 링크를 가리지 않는다).
 */

import { PROMO_BRAND, PROMO_TEXT_LONG, PROMO_TEXT_SHORT, PROMO_URL } from './promo.js';

export function PromoBar(): JSX.Element {
  return (
    <aside className="promo" aria-label="프로젝트팀포유 소개">
      <a className="promo__link" href={PROMO_URL} target="_blank" rel="noopener noreferrer">
        <b className="promo__brand">{PROMO_BRAND}</b>
        <span className="promo__text promo__text--long">{PROMO_TEXT_LONG}</span>
        <span className="promo__text promo__text--short">{PROMO_TEXT_SHORT}</span>
        <span className="promo__arrow" aria-hidden="true">
          ↗
        </span>
        <span className="promo__sr"> (새 창에서 열림)</span>
      </a>
    </aside>
  );
}
